module.exports = __webpack_public_path__ + "static/media/eaglesLogo-symbol.9b5e5644.jpg";